import {GET, POST} from "../util";

const inspectionUrl = "api/risk-assessment-inspection";
const operationUrl = "api/risk-assessment-operation";

const url = {
    inspection: {
        sellers: `${inspectionUrl}/sellers/list`,
        debtors: `${inspectionUrl}/debtors/list`,
        counts: `${inspectionUrl}/counts`,
    },
    operation: {
        approve: `${operationUrl}/config/:configId/approve`,
        reject: `${operationUrl}/config/:configId/reject`,
    }
};

const riskAssessmentApi = {
    inspection: {
        listDebtors: (params = {}) => {
            return POST(url.inspection.debtors, params);
        },
        listSellers: (params = {}) => {
            return POST(url.inspection.sellers, params);
        },
        getCounts: () => {
            return GET(url.inspection.counts);
        }

    },
    operation: {
        approveInvestorConfig: (configId) => {
            return POST(url.operation.approve.replace(":configId",configId), {});
        },
        rejectInvestorConfig: (configId) => {
            return POST(url.operation.reject.replace(":configId",configId), {});
        },
    }
};

export {
    riskAssessmentApi
};
